document.addEventListener("DOMContentLoaded", function () {
  const buttomMenuOpen = document.querySelector(".icon-hamburguer-menu");
  const buttonMenuCLose = document.querySelector(".btn-close-menu-mobile");
  const iconMenuCLose = document.querySelector(".icon-close-menu-mobile");
  const buttonsCategoriesMenuMobile = document.querySelectorAll(".categorie-content-mobile");
  const buttonsSubCategoriesMenuMobile = document.querySelectorAll(".subcategorie-button");
  const buttonsCloseSubCategoriesMenuMobile = document.querySelectorAll( ".close-modal-subcategories-link");
  const modalsMobile = document.querySelectorAll(".submanu-modal-content");
  const buttonsOpenCategory = document.querySelectorAll(".ope-menu-desktop");
  const swrapperCloseCategory = document.querySelectorAll( ".subcategorie-swrapper-open");
  const menusCloseMouseLeave = document.querySelectorAll(".subcategories-container");

  function HandleModalCategorieMenus(subMenus, ElementSelected) {
    subMenus.forEach((element) => {
      if (
        element.nextElementSibling.classList.contains(
          "subcategorie-swrapper-open"
        )
      ) {
        element.nextElementSibling.classList = "subcategorie-swrapper";
      }
      if (element.id === ElementSelected.id) {
        console.log({ element: element, ElementSelected: ElementSelected });
        element.nextElementSibling.classList = "subcategorie-swrapper-open";
      }
    });
  }
  function closeMenusDesktop() {
    document
      .querySelectorAll(".subcategorie-swrapper-open")
      .forEach((element) => {
        element.classList = "subcategorie-swrapper";
      });
  }
  function selectCategorieMobileMenu(buttons, categorieElement) {
    buttons.forEach((element) => {
      if (
        element.children[1].classList.contains(
          "subategorie-selected-mobile-menu"
        )
      ) {
        element.children[1].classList.remove(
          "subategorie-selected-mobile-menu"
        );
      }
      if (element.id === categorieElement.id) {
        element.children[1].classList.add("subategorie-selected-mobile-menu");

      }
      console.log(element.children[1]);
    });
  }
  function HandleModalSubcategorieChilds(subMenus, submenuElementSelected) {
    console.log({ subMenus, submenuElementSelected });
    subMenus.forEach((element) => {
      if (
        element.nextElementSibling.classList.contains(
          "modal-selected-mobile-menu"
        )
      ) {
        element.nextElementSibling.classList.remove(
          "modal-selected-mobile-menu"
        );
      }
      if (element.id === submenuElementSelected.id) {
        element.nextElementSibling.classList.add("modal-selected-mobile-menu");
      }
    });
  }
  function HandleCloseModalSubcategoriesChilds() {
    console.log("close");
    modalsMobile.forEach((element) => {
      console.log({ element });
      element.classList = "submanu-modal-content ";
    });
  }
  function openMenusMobile() {
    document.querySelector(".header-container-menus-mobile-close").classList =
      "header-container-menus-mobile";
  }
  function closeMenusMobile() {
    document.querySelector(".header-container-menus-mobile").classList =
      "header-container-menus-mobile-close";
  }
  buttonsCategoriesMenuMobile.forEach((element) => {
    element.addEventListener("click", () => {
      selectCategorieMobileMenu(buttonsCategoriesMenuMobile, element);
    });
  });
  buttonsSubCategoriesMenuMobile.forEach((element) => {
    element.addEventListener("click", () => {
      // HandleModalSubcategorieChilds(buttonsSubCategoriesMenuMobile, element);
    });
  });
  buttonsCloseSubCategoriesMenuMobile.forEach((element) => {
    element.addEventListener("click", () => {
      HandleCloseModalSubcategoriesChilds(buttonsSubCategoriesMenuMobile);
    });
  });
  buttomMenuOpen.addEventListener("click", () => {
    openMenusMobile();
  });
  buttonMenuCLose.addEventListener("click", () => {
    closeMenusMobile();
  });
  iconMenuCLose.addEventListener("click", () => {
    closeMenusMobile();
  });
  buttonsCategoriesMenuMobile[0].children[1].classList.add(
    "subategorie-selected-mobile-menu"
  );
  buttonsCategoriesMenuMobile[0].children[0].classList.add("active-category-mobile");
  buttonsOpenCategory.forEach((element) => {
    element.addEventListener("click", () => {
      HandleModalCategorieMenus(buttonsOpenCategory, element);
    });
  });
  menusCloseMouseLeave.forEach((element) => {
    element.addEventListener("mouseleave", () => {
      closeMenusDesktop(swrapperCloseCategory, element);
    });
  });
});
